module.exports = __webpack_public_path__ + "static/media/wechat_logo.3fda3a3f.svg";